
























































import Vue from "vue";
import { Manager } from "@infoland/iprova-api";
import CardProperty from "./CardProperty.vue";
import { Membership, Team } from "@/teams";

export default Vue.extend({
    name: "TeamCard",
    components: { CardProperty },
    props: {
        /** The team represented by this card */
        team: { type: Object as () => Team, required: true }
    },
    data: function () {
        return {
            /** The model for the tab view on the card */
            tab: null as number
        };
    },
    computed: {
        /** Gets the members of the team, sorted alphabetically by name */
        sortedMembers(): Membership[] {
            const returnValue: Membership[] = [].concat(this.team.memberships);
            return returnValue.sort((a, b) => {
                var textA: string = a.name.toUpperCase();
                var textB: string = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
        },
        /** Gets the managers of the team, sorted alphabetically by name */
        sortedManagers(): Manager[] {
            const returnValue: Manager[] = [].concat(this.team.managers);
            return returnValue.sort((a, b) => {
                var textA: string = a.name.toUpperCase();
                var textB: string = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
        }
    },
    methods: {
        /** Gets the key of the given member (the id)
         * @param member The member to get the key of
         * @returns The id of the user or group that the member describes
         */
        getMemberKey(member: Membership): string {
            return member.user_id ? member.user_id : member.user_group_id;
        },
        /** Closes the card by emitting 'close' */
        closeCard(): void {
            this.$emit("close");
        }
    }
});
